import { render, staticRenderFns } from "./VBirthdateInput.vue?vue&type=template&id=40bce41c&scoped=true&"
import script from "./VBirthdateInput.vue?vue&type=script&lang=ts&"
export * from "./VBirthdateInput.vue?vue&type=script&lang=ts&"
import style0 from "./VBirthdateInput.vue?vue&type=style&index=0&id=40bce41c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bce41c",
  null
  
)

export default component.exports